import React from 'react';

function Footer() {
  return (
    <div style={{ backgroundColor: 'black', color: 'white', padding: '16px', textAlign: 'center' }}>
      <p>&copy; 2025 Alliance Law Group. All Rights Reserved.</p>
      <a 
        href="https://www.linkedin.com/company/alliancelawgroup/" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{ display: 'inline-block', marginTop: '8px' }}
      >
        <img 
          src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/linkedin.svg" 
          alt="LinkedIn"
          style={{ width: '24px', height: '24px', filter: 'invert(1)' }} 
        />
      </a>
    </div>
  );
}

export default Footer;
